import { type CountryCode } from 'libphonenumber-js'
import { type IRcsCountryCode } from 'entities/Rcs/api/rcsComplianceTypes'

export type IRcsSupportedCountry = {
  isoCode: CountryCode
  rcsCode: IRcsCountryCode
  label: string
}

export const RCS_SUPPORTED_COUNTRIES: ReadonlyArray<IRcsSupportedCountry> = [
  { isoCode: 'US', rcsCode: 'us', label: 'United States' },
  { isoCode: 'CA', rcsCode: 'ca', label: 'Canada' },
  { isoCode: 'GB', rcsCode: 'uk', label: 'United Kingdom' },
]
